import { useQuery } from '@tanstack/react-query';
import { getUserServices } from '../api/reportsApi';
import { msalInstance } from '@utils';

export const useUserServices = () => {
  return useQuery({
    queryKey: ['userServices'],
    queryFn: getUserServices,
    enabled: msalInstance.getAllAccounts().length > 0,
    staleTime: 5 * 60 * 1000,
  });
};
